module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf-900.eb967166.svg";